export default {
  SERVER_STATUS_REQUEST: 'SERVER_STATUS_REQUEST',
  SERVER_STATUS_SUCCESS: 'SERVER_STATUS_SUCCESS',
  SERVER_STATUS_FAILURE: 'SERVER_STATUS_FAILURE',
};
